import { Field, HelpTooltip } from '~/components';
import React from 'react';
import styled from 'styled-components';

const Control = styled.div`
  display: flex;
  align-items: center;
`;

export default function CapMonthlyHoursCheckbox() {
  return (
    <Control>
      <Field.Checkbox name="capMonthlyHours" label="Cap the total hours" />

      <HelpTooltip
        message="Do not allow a time entry to be saved if it will cause the project to exceed its monthly billable or non-billable hours budget."
        style={{ marginLeft: '.5rem' }}
      />
    </Control>
  );
}
